// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__19Sq3","buttons":"RemoveExpirationActionButtons_buttons__1J4pL"};